export default __webpack_public_path__ + "static/media/brave_zone_xl1.a6890f9d.png";